import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { cn } from '@/lib/utils'

export type UserAvatarUser = {
  name?: string | null
  media?: { url?: string }[] | null
}

export type UserAvatarProps = {
  user?: UserAvatarUser | null
  className?: string
  fallbackClassName?: string
  imageClassName?: string
}

const UserAvatar = ({ user, className, fallbackClassName, imageClassName }: UserAvatarProps) => {
  const profileImage = user?.media?.[0]

  // Get user initials for fallback
  const getUserInitials = (name: string | null | undefined) => {
    if (!name) return ''
    return name
      .split(' ')
      .map((s) => s[0])
      .slice(0, 2)
      .join('')
      .toUpperCase()
  }

  return (
    <Avatar className={cn('h-8 w-8 rounded-lg', className)}>
      <AvatarImage src={profileImage?.url} className={imageClassName} />
      <AvatarFallback
        className={cn(
          'rounded-lg bg-action text-action-foreground font-semibold text-sm',
          fallbackClassName
        )}
      >
        {getUserInitials(user?.name)}
      </AvatarFallback>
    </Avatar>
  )
}

export default UserAvatar
